import { privateApi } from '@/config/axios.config';

export interface SubscriptionInvoice {
  id: string;
  invoiceNumber: string;
  amount: number;
  currency: string;
  status: 'paid' | 'pending' | 'overdue' | 'cancelled';
  issueDate: string;
  dueDate: string;
  paidDate?: string;
  paymentMethod?: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface InvoicesResponse {
  invoices: SubscriptionInvoice[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

/**
 * API service para facturas de suscripción en settings
 * Obtiene las facturas del tenant actual
 */
export const settingsInvoicesApi = {
  /**
   * Obtener facturas del tenant actual
   */
  getInvoices: async (filters?: {
    status?: string;
    page?: number;
    limit?: number;
  }): Promise<InvoicesResponse> => {
    try {
      const params = new URLSearchParams();
      if (filters?.status) {
        params.append('status', filters.status);
      }
      if (filters?.page) {
        params.append('page', filters.page.toString());
      }
      if (filters?.limit) {
        params.append('limit', filters.limit.toString());
      }

      // Usar el endpoint de billing/invoices con el tenant del usuario autenticado
      const response = await privateApi.get('/billing/invoices', { params });
      
      // El backend debería retornar solo las facturas del tenant actual
      const invoicesData = response.data?.data || response.data || [];
      
      return {
        invoices: Array.isArray(invoicesData) ? invoicesData : [],
        total: invoicesData.length || 0,
        page: filters?.page || 1,
        limit: filters?.limit || 10,
        totalPages: Math.ceil((invoicesData.length || 0) / (filters?.limit || 10)),
      };
    } catch (error: any) {
      throw error;
    }
  },

  /**
   * Obtener una factura por ID
   */
  getInvoiceById: async (id: string): Promise<SubscriptionInvoice> => {
    const response = await privateApi.get(`/billing/invoices/${id}`);
    return response.data?.data || response.data;
  },
};

